import ks from "../ReUsableTS/kalmstromShared4";
import { khtmlButton, kHTMLRow, kHTMLTable } from "../ReUsableTS/kHTML";
import LNG from "../ReUsableTS/kLNG";

export enum kMultiSelectOptionType{
    All,
    Unique,//If this option is selected none other can be selected
    Normal
}
export class kMultiSelectOption {
    public Text = "";
    public Visible = true;

    public OptionType:kMultiSelectOptionType = kMultiSelectOptionType.Normal;
    public SelectedOptionSpan: HTMLSpanElement | null = null;
    public RemoveSpan: HTMLSpanElement | null = null; //The small icon to remove the selected option

    public AvailableDiv: HTMLDivElement | null = null;
    public OptInput: HTMLInputElement | null = null;
    
    public AvailableIcon: HTMLSpanElement | null = null;
    public SelectedIcon: HTMLSpanElement | null = null;
    public Parent: kHTMLMultiSelect | null = null;


    public ToSelectedOption = (): HTMLSpanElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("span");
        }
        try {
            if(this.SelectedOptionSpan){
                this.SelectedOptionSpan.remove();
                this.SelectedOptionSpan = null;
            }
            this.SelectedOptionSpan = document.createElement("span");
            this.SelectedOptionSpan.className = "optext";
 
            if(this.SelectedIcon){
                this.SelectedOptionSpan.appendChild(this.SelectedIcon);
            }
            const OptionLabel:HTMLSpanElement = document.createElement("span");
            OptionLabel.textContent = this.Text;
            this.SelectedOptionSpan.appendChild(OptionLabel);

            this.RemoveSpan = document.createElement("span");
            this.RemoveSpan.className = "optdel";
            this.RemoveSpan.title = LNG.REMOVE;
            this.RemoveSpan.textContent = "x";
            this.RemoveSpan.addEventListener("click", this.RemoveClick);
            this.SelectedOptionSpan.appendChild(this.RemoveSpan);
            return this.SelectedOptionSpan;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kMultiSelectOption.ToSelectedOption");
            return document.createElement("span");
        }
    };
    public RemoveClick = (Event: MouseEvent): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.SelectedOptionSpan && this.Parent) {
                if(this.Text !== LNG.ALL){
                    this.DeSelectChoice();
                    if(this.Parent.CountNormalUnSelected() === this.Parent.Choices.length){
                        if(this.Parent.NoneSelectedOptionText !== ""){
                            this.Parent.SetSelectedChoices([this.Parent.NoneSelectedOptionText]);
                        }
                    }
                    if(this.Parent && this.Parent.ChangeCB){
                        this.Parent.ChangeCB(this.Parent.SelectedChoices());
                    }
                }else{
                    this.Parent.DeSelectAll()
                }
                if(this.Parent && this.Parent.OKClickCB){
                    this.Parent.OKClickCB();
                }
                Event.preventDefault();
                Event.stopPropagation();

            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kMultiSelectOption.RemoveClick");
            return;
        }
    };
    public ToAvailableOption = (): HTMLDivElement  => {
        if (ks.kErrorMode === true) {
            return document.createElement("div");
        }
        try {
            this.AvailableDiv = document.createElement("div");
            this.OptInput = document.createElement("input");
            this.OptInput.type = "checkbox";
            this.OptInput.addEventListener("click", this.ItemChecked);

            // const OptLabel: HTMLLabelElement = document.createElement("label");
            // OptLabel.addEventListener("click", this.LabelClick);

            // const OptInnerSpan:HTMLSpanElement = document.createElement("span");
            // OptInnerSpan.textContent = this.Text;
            // OptLabel.appendChild(OptInnerSpan);

            const RowTable:kHTMLTable = new kHTMLTable();
            RowTable.Table.className = "kMultiChoicOptionTable";
            RowTable.Table.addEventListener("click", this.LabelClick);
            const SingleRow:kHTMLRow = RowTable.AddEmptyRow();
            if(this.AvailableIcon){
                const IconCell:HTMLTableCellElement =SingleRow.AddCellWithElement(this.AvailableIcon);
                IconCell.style.width = "20px";
                IconCell.style.maxWidth = "20px";
            }
            const InputCell:HTMLTableCellElement = SingleRow.AddCellWithElement(this.OptInput);
            InputCell.style.width = "18px";
            InputCell.style.maxWidth= "18px"

            const LabelCell:HTMLTableCellElement = SingleRow.AddCell(this.Text);
            LabelCell.style.position = "relative";
            LabelCell.style.top = "-2px";
            // this.AvailableDiv.className = "kMultiChoiceOptionAvailableDiv";
            // this.AvailableDiv.appendChild(this.OptInput);

            // if(this.AvailableIcon){
            //     OptLabel.appendChild(this.AvailableIcon);
            // }
            // this.AvailableDiv.appendChild(OptLabel);
            this.AvailableDiv.appendChild(RowTable.Table);
            return this.AvailableDiv;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kMultiSelectOption.ToAvailableOption");
            return document.createElement("div");
        }
    };
    public LabelClick = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if(this.OptInput){
                this.OptInput.checked = !this.OptInput.checked;
                this.ItemChecked();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kMultiSelectOption.LabelClick");
            return;
        }
    };
    public SelectChoice = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.OptInput && this.Parent && this.Parent.OuterDiv) {
                this.OptInput.checked = true;
                this.Parent.OuterDiv.appendChild(this.ToSelectedOption());
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kMultiSelectOption.SelectChoice");
            return;
        }
    };
    public DeSelectChoice = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.OptInput && this.Parent && this.Parent.OuterDiv) {
                this.OptInput.checked = false;
                if (this.SelectedOptionSpan) {
                    this.SelectedOptionSpan.remove();
                    this.SelectedOptionSpan = null;
                }
                this.Parent.AllSelected = false;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kMultiSelectOption.DeSelectChoice");
            return;
        }
    };
    public ItemChecked = (Event?: MouseEvent): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if(this.OptInput && this.Parent){
                switch (this.OptionType){
                    case kMultiSelectOptionType.All:
                        if(this.OptInput.checked){
                            this.Parent.SelectAll();
                        }else{
                            this.Parent.DeSelectAll();
                        }
                        break;
                    case kMultiSelectOptionType.Unique:
                        if(this.OptInput.checked){
                            this.Parent.DeSelectAll();
                            this.Parent.SetSelectedChoices([this.Text]);
                        }
                        break;
                    case kMultiSelectOptionType.Normal:
                        if(this.OptInput.checked){
                            this.Parent.DeSelectUniques();
                            //One more selected - does that mean all?
                            if(this.Parent.CountNormalUnSelected() === 0){
                                this.Parent.SelectAll();
                            }
                        }else{
                            //One less selected
                            this.Parent.AllSelected = false;
                            this.DeSelectChoice();
                            if(this.Parent && this.Parent.AllOption && this.Parent.AllOption.OptInput){
                                this.Parent.AllOption.OptInput.checked = false;
                                if(this.Parent.AllOption.SelectedOptionSpan){
                                    this.Parent.AllOption.SelectedOptionSpan.remove();
                                    this.Parent.AllOption.SelectedOptionSpan= null;
                                }
                            }
                            break;
                        }
                }
            }
            if(Event){
                Event.stopPropagation();
            }
            if(this.Parent && this.Parent.ChangeCB){
                this.Parent.ChangeCB(this.Parent.SelectedChoices());
            }   
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kMultiSelectOption.ItemChecked");
        }
    };

}

export class kHTMLMultiSelect {
    public Search = true;

    public Height = "15rem";
    public Width = "100%";
    public Placeholder: string = LNG.SELECT;
    public Choices: string[] = [];
    public ChoiceOptions: kMultiSelectOption[] = [];
    public ListWrapper: HTMLDivElement | null = null;
    public SearchInput: HTMLInputElement | null = null;
    public AllOption: kMultiSelectOption | null = null;
    public OuterDiv: HTMLDivElement = document.createElement("div");
    public OKButton: khtmlButton = new khtmlButton();
    public ChangeCB: ((Selected: string[]) => void) | null = null;
    public OKClickCB: (() => void) | null = null;
    public AllSelected:boolean = false;
    public NoneSelectedOptionText: string = "";
    public ShowAllOption: boolean = false;

    public AddStyles = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const ExistingStyle = document.getElementById(
                "kHTMLMultiSelectStyles"
            );
            if (ExistingStyle === null) {
                const Style = document.createElement("style");
                Style.id = "kHTMLMultiSelectStyles";
                Style.innerHTML = `
                .kMultiChoicOptionTable{
                    border-collapse:collapse;
                    width:100%;
                    overflow:hidden;
                    cursor:pointer;
                    user-select:none;
                }
                .kMultiChoicOptionTable:hover{
                    background:rgba(123,97,255,0.08);
                    color:#1A1F2E;
                }
                .kMultiChoicOptionTable td{
                    border:none;
                    padding:0;
                }
                .multiselect-dropdown{
                    display:inline-block;
                    padding:4px 28px 4px 10px;
                    border-radius:10px;
                    border:1px solid #E2E5EC;
                    background-color:#fff;
                    position:relative;
                    font-family:inherit;
                    font-size:13px;
                    color:#1A1F2E;
                    min-height:34px;
                    background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%235E6782' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
                    background-repeat:no-repeat;
                    background-size:12px 10px;
                    background-position:right 10px center;
                    transition:border-color 180ms;
                    cursor:pointer;
                }
                .multiselect-dropdown:hover{
                    border-color:#7B61FF;
                }
                .optext{
                    float:left;
                }
                .multiselect-dropdown span.optext, .multiselect-dropdown span.placeholder{
                    margin-right:6px;
                    margin-bottom:2px;
                    padding:0;
                    border-radius:6px;
                    display:inline-block;
                }
                .multiselect-dropdown span.optext{
                    background:#F0ECFF;
                    color:#7B61FF;
                    padding:3px 10px;
                    font-size:12px;
                    font-weight:600;
                }
                .multiselect-dropdown span.optext .optdel{
                    float:right;
                    margin:0 -4px 0 6px;
                    font-size:0.75em;
                    cursor:pointer;
                    color:#7B61FF;
                    opacity:0.5;
                    transition:opacity 150ms;
                }
                .multiselect-dropdown span.optext .optdel:hover{opacity:1;}
                .multiselect-dropdown span.placeholder{
                    color:#94A3B8;
                    font-size:13px;
                }
                .multiselect-dropdown-list-wrapper{
                    box-shadow:0 8px 24px rgba(0,0,0,0.12);
                    z-index:100;
                    padding:8px;
                    border-radius:10px;
                    border:1px solid #E2E5EC;
                    display:none;
                    margin:-1px;
                    position:absolute;
                    top:0;
                    left:0;
                    min-width:100%;
                    min-width:max(100%,280px);
                    background:#fff;
                }
                .multiselect-dropdown-list-wrapper .multiselect-dropdown-search{
                    margin-bottom:8px;
                    border-radius:8px;
                    border:1px solid #E2E5EC;
                    padding:7px 12px;
                    font-size:13px;
                    font-family:inherit;
                    outline:none;
                    box-sizing:border-box;
                    transition:border-color 180ms;
                    color:#1A1F2E;
                }
                .multiselect-dropdown-list-wrapper .multiselect-dropdown-search:focus{
                    border-color:#7B61FF;
                }
                .multiselect-dropdown-list{
                    padding:2px;
                    height:15rem;
                    overflow-y:auto;
                    overflow-x:hidden;
                }
                .multiselect-dropdown-list::-webkit-scrollbar{
                    width:6px;
                }
                .multiselect-dropdown-list::-webkit-scrollbar-thumb{
                    background-color:rgba(123,97,255,0.25);
                    border-radius:3px;
                }
                .multiselect-dropdown-list div{
                    padding:5px 8px;
                    border-radius:6px;
                }
                .multiselect-dropdown-list input{
                    height:1.15em;
                    width:1.15em;
                    margin-right:0.35em;
                    accent-color:#7B61FF;
                    cursor:pointer;
                }
                .multiselect-dropdown-list div:hover{
                    background-color:rgba(123,97,255,0.06);
                }
                .multiselect-dropdown span.maxselected{width:100%;}
                .multiselect-dropdown-all-selector{
                    border-bottom:1px solid #E2E5EC;
                    padding:6px 8px;
                    margin-bottom:4px;
                }
                `;
                document.head.appendChild(Style);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.AddStyles");
            return;
        }
    };

    public CountNormalUnSelected = (): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            let NormalsUnSelected:number = 0;
            for(const CurrChoice of this.ChoiceOptions){
                if(CurrChoice.OptionType === kMultiSelectOptionType.Normal){
                    if(CurrChoice.OptInput){
                        if(CurrChoice.OptInput.checked ===false){
                            NormalsUnSelected++;
                        }
                    }
                }
            }
            return NormalsUnSelected;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.CountNormalUnSelected");
            return 0;
        }
    };
    public DeSelectUniques = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.ChoiceOptions) {
                for (const Choice of this.ChoiceOptions) {
                    if (Choice.OptionType === kMultiSelectOptionType.Unique === true && Choice.Visible === true) {
                        if(Choice.OptInput){
                            if(Choice.OptInput.checked === true){
                                Choice.DeSelectChoice();
                            }
                        }
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.DeSelectUniques");
            return;
        }
    };
    public SelectAll = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            //this.OuterDiv.innerHTML = "";
            let HiddenOptionsExist = false;
            if (this.ChoiceOptions) {
                for (const Choice of this.ChoiceOptions) {
                    if (Choice.Visible === true) {
                        if(Choice.OptionType!== kMultiSelectOptionType.Unique){
                            if(Choice.OptInput){
                                Choice.OptInput.checked = true;
                            }
                        }else{
                            Choice.DeSelectChoice()
                            if(Choice.OptInput){
                                Choice.OptInput.checked = false;
                            }
                        }
                    }else{
                        HiddenOptionsExist = true;
                    }
                }
            }
            if(HiddenOptionsExist === true){
                if(this.CountNormalUnSelected() === 0){
                    HiddenOptionsExist= false;
                }
            }
            if(HiddenOptionsExist === false){
                if(this.AllOption){
                    if(this.AllOption.OptInput){
                        this.AllOption.OptInput.checked = true;
                    }
                    this.OuterDiv.appendChild(this.AllOption.ToSelectedOption());
                }
                this.AllSelected = true;
            }else{
                this.AllSelected = false;
                if(this.AllOption){
                    this.AllOption.DeSelectChoice();
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.SelectAll");
            return;
        }
    };
    public uncheckAll = (): void => {
        this.DeSelectAll();
    };
    public checkAll = (): void => {
        this.SelectAll();
    };
    public SelectedChoices = (): string[] => {
        if (ks.kErrorMode === true) {
            return [];
        }
        try {
            const ReturnArray: string[] = [];
            for (const Choice of this.ChoiceOptions) {
                if(Choice.OptInput){
                    if (Choice.OptInput.checked === true) {
                        ReturnArray.push(Choice.Text);
                    }
                }
            }
            return ReturnArray;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.SelectAll");
            return [];
        }
    };
    public DeSelectAll = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.ChoiceOptions) {
                for (const Choice of this.ChoiceOptions) {
                    if (Choice.Visible === true) {
                        Choice.DeSelectChoice();
                    }
                }
            }
            if(this.AllOption){
                this.AllOption.DeSelectChoice();
            }
            this.AllSelected = false;
            if(this.NoneSelectedOptionText !== ""){
                this.SetSelectedChoices([this.NoneSelectedOptionText]);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.DeSelectAll");
            return;
        }
    };

    public DocumentClick = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.ListWrapper && this.SearchInput) {
                this.ListWrapper.style.display = "none";
                document.removeEventListener("click", this.DocumentClick);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.DocumentClick");
        }
    };
    public SetSelectedChoices = (NewSelections: string[]): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let CurrSelection = "";
            let NoneCaption:string = "";
            if (this.SearchInput) {
                this.SearchInput.textContent = "";
            }
            this.SearchInputChanged();
            if(NewSelections.length>0 && this.NoneSelectedOptionText !== ""){
                NoneCaption = this.NoneSelectedOptionText;
                this.NoneSelectedOptionText = "";
                this.DeSelectAll();
                this.NoneSelectedOptionText = NoneCaption; 
            }else{
                this.DeSelectAll();
            }
            for (CurrSelection of NewSelections) {
                for (const Choice of this.ChoiceOptions) {
                    if (Choice.Text === CurrSelection) {
                        Choice.SelectChoice();
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.SetSelectedChoices");
            return;
        }
    };
    public ToDiv = (): HTMLDivElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("div");
        }
        try {
            let CurrentValue = "";
            this.AddStyles();

            this.OuterDiv = document.createElement("div");
            this.OuterDiv.classList.add("multiselect-dropdown");
            this.OuterDiv.style.width = this.Width;

            this.ListWrapper = document.createElement("div");
            this.ListWrapper.className = "multiselect-dropdown-list-wrapper";

            this.SearchInput = document.createElement("input");
            this.SearchInput.classList.add("multiselect-dropdown-search");
            this.SearchInput.classList.add("form-control");
            this.SearchInput.placeholder = LNG.SEARCH;
            this.SearchInput.style.width = this.Width;
            this.SearchInput.addEventListener("input", this.SearchInputChanged);
            this.ListWrapper.appendChild(this.SearchInput);

            const ClearLink: HTMLSpanElement = document.createElement("span");
            ClearLink.textContent = "× Clear";
            ClearLink.style.cssText = "float:right;cursor:pointer;font-size:11px;color:#7B61FF;padding:4px 8px;user-select:none;font-weight:600;";
            ClearLink.addEventListener("click", this.DeSelectAll);
            this.ListWrapper.appendChild(ClearLink);

            // const TopOKButton = new khtmlButton();
            // TopOKButton.SetText(LNG.OK);
            // TopOKButton.SetCallBack(this.OKClick);
            // TopOKButton.Button.style.cssFloat = "right";
            // TopOKButton.Button.style.marginRight = "10px";
            // TopOKButton.Button.style.marginTop = "-2px";

            // this.ListWrapper.appendChild(TopOKButton.Button);
            if (this.ShowAllOption) {
                this.AllOption = new kMultiSelectOption();
                this.AllOption.Text = LNG.ALL;
                this.AllOption.Parent = this;
                this.AllOption.OptionType = kMultiSelectOptionType.All;
                this.AllOption.ToAvailableOption();
                if (this.AllOption.AvailableDiv) {
                    this.AllOption.AvailableDiv.className =
                        "multiselect-dropdown-all-selector";
                    this.ListWrapper.appendChild(this.AllOption.AvailableDiv);
                }
            }
            if(this.Choices.length > 0){
                this.Choices.sort();
                for (CurrentValue of this.Choices) {
                    const NewMultiSelectOption = new kMultiSelectOption();
                    NewMultiSelectOption.Text = CurrentValue;
                    const NewDiv: HTMLDivElement | null =
                        NewMultiSelectOption.ToAvailableOption();
                    if (NewDiv) {
                        this.ListWrapper.appendChild(NewDiv);
                    }
                    NewMultiSelectOption.Parent = this;
                    this.ChoiceOptions.push(NewMultiSelectOption);
                }
            }else{
                for(const Option of this.ChoiceOptions){
                    const NewDiv: HTMLDivElement | null =
                        Option.ToAvailableOption();
                    if (NewDiv) {
                        this.ListWrapper.appendChild(NewDiv);
                    }
                    Option.Parent = this;
                }
            }
            this.OuterDiv.appendChild(this.ListWrapper);
            this.OuterDiv.addEventListener("click", this.DivClick);

            this.OKButton = new khtmlButton();
            this.OKButton.SetText(LNG.OK);
            this.OKButton.SetCallBack(this.OKClick);
            if (this.OKButton.Button) {
                const OKBtn: HTMLButtonElement = this.OKButton.Button;
                OKBtn.style.cssFloat = "right";
                OKBtn.style.margin = "8px";
                OKBtn.style.padding = "6px 16px";
                OKBtn.style.fontSize = "12px";
                OKBtn.style.fontWeight = "600";
                OKBtn.style.background = "#7B61FF";
                OKBtn.style.color = "white";
                OKBtn.style.border = "none";
                OKBtn.style.borderRadius = "8px";
                OKBtn.style.cursor = "pointer";
                OKBtn.style.boxShadow = "none";
                OKBtn.style.transform = "none";
                OKBtn.style.transition = "background 150ms";
                this.ListWrapper.appendChild(OKBtn);
            }

            return this.OuterDiv;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.ToDiv");
            return document.createElement("div");
        }
    };
    /**
     * Update the available choices after the component has been rendered.
     * Preserves selections that still exist in the new choices.
     * @param NewChoices The new list of choice strings
     */
    public SetChoices = (NewChoices: string[]): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const PrevSelected: string[] = this.SelectedChoices();

            if (this.ListWrapper === null) { return; }

            for (const Opt of this.ChoiceOptions) {
                if (Opt.AvailableDiv !== null) { Opt.AvailableDiv.remove(); }
                if (Opt.SelectedOptionSpan !== null) { Opt.SelectedOptionSpan.remove(); }
            }
            this.ChoiceOptions = [];
            this.AllSelected = false;

            NewChoices.sort();
            this.Choices = NewChoices;

            const OKBtn: HTMLElement | null = this.ListWrapper.querySelector("button");

            for (const ChoiceText of NewChoices) {
                const NewOpt: kMultiSelectOption = new kMultiSelectOption();
                NewOpt.Text = ChoiceText;
                NewOpt.Parent = this;
                const NewDiv: HTMLDivElement = NewOpt.ToAvailableOption();
                if (OKBtn !== null) {
                    this.ListWrapper.insertBefore(NewDiv, OKBtn);
                } else {
                    this.ListWrapper.appendChild(NewDiv);
                }
                this.ChoiceOptions.push(NewOpt);
            }

            const StillValid: string[] = [];
            const NewSet: Set<string> = new Set(NewChoices);
            for (const Prev of PrevSelected) {
                if (NewSet.has(Prev)) { StillValid.push(Prev); }
            }
            if (StillValid.length > 0) {
                this.SetSelectedChoices(StillValid);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.SetChoices");
        }
    };

    public SearchInputChanged = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.ListWrapper && this.SearchInput) {
                const SearchValue: string =
                    this.SearchInput.value.toUpperCase();
                for (const Choice of this.ChoiceOptions) {
                    if (
                        Choice.Text.toUpperCase().indexOf(SearchValue) > -1 ||
                        SearchValue === ""
                    ) {
                        if (Choice.AvailableDiv) {
                            Choice.AvailableDiv.style.display = "block";
                            Choice.Visible = true;
                        }
                    } else {
                        if (Choice.AvailableDiv) {
                            Choice.AvailableDiv.style.display = "none";
                            Choice.Visible = false;
                        }
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.SearchInputChanged");
        }
    };
    public OKClick = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            for (const Choice of this.ChoiceOptions) {
                if (Choice.SelectedOptionSpan) {
                    Choice.SelectedOptionSpan.remove();
                    Choice.SelectedOptionSpan = null;
                }
            }
            if(this.AllSelected ===false){
                for (const Choice of this.ChoiceOptions) {
                    if(Choice.OptInput && Choice.OptInput.checked === true){
                        this.OuterDiv.appendChild(Choice.ToSelectedOption());
                    }
                }
            }
            this.DocumentClick();
            if (this.OKClickCB) { this.OKClickCB(); }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.OKClick");
        }
    };
    public DivClick = (Event: MouseEvent): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.ExpandListWrapper();
            Event.preventDefault();
            Event.stopPropagation();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.DivClick");
        }
    };
    public ExpandListWrapper = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.ListWrapper && this.SearchInput) {
                this.ListWrapper.style.display = "block";
                this.SearchInput.focus();
                this.SearchInput.select();
                document.addEventListener("click", this.DocumentClick);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLMultiSelect.ExpandListWrapper");
        }
    };
}

//https://admirhodzic.github.io/multiselect-dropdown/demo.html

//           function newEl(tag,attrs){
//             var e=document.createElement(tag);
//             if(attrs!==undefined) Object.keys(attrs).forEach(k=>{
//               if(k==='class') { Array.isArray(attrs[k]) ? attrs[k].forEach(o=>o!==''?e.classList.add(o):0) : (attrs[k]!==''?e.classList.add(attrs[k]):0)}
//               else if(k==='style'){
//                 Object.keys(attrs[k]).forEach(ks=>{
//                   e.style[ks]=attrs[k][ks];
//                 });
//                }
//               else if(k==='text'){attrs[k]===''?e.innerHTML='&nbsp;':e.innerText=attrs[k]}
//               else e[k]=attrs[k];
//             });
//             return e;
//           }

//           document.querySelectorAll("select[multiple]").forEach((el,k)=>{

//             var div=newEl('div',{class:'multiselect-dropdown',style:{width:config.style?.width??el.clientWidth+'px',padding:config.style?.padding??''}});
//             el.style.display='none';
//             el.parentNode.insertBefore(div,el.nextSibling);
//             var listWrap=newEl('div',{class:'multiselect-dropdown-list-wrapper'});
//             var list=newEl('div',{class:'multiselect-dropdown-list',style:{height:config.height}});
//             var search=newEl('input',{class:['multiselect-dropdown-search'].concat([config.searchInput?.class??'form-control']),style:{width:'100%',display:el.attributes['multiselect-search']?.value==='true'?'block':'none'},placeholder:config.txtSearch});
//             listWrap.appendChild(search);
//             div.appendChild(listWrap);
//             listWrap.appendChild(list);

//             el.loadOptions=()=>{
//               list.innerHTML='';

//               if(el.attributes['multiselect-select-all']?.value=='true'){
//                 var op=newEl('div',{class:'multiselect-dropdown-all-selector'})
//                 var ic=newEl('input',{type:'checkbox'});
//                 op.appendChild(ic);
//                 op.appendChild(newEl('label',{text:config.txtAll}));

//                 op.addEventListener('click',()=>{
//                   op.classList.toggle('checked');
//                   op.querySelector("input").checked=!op.querySelector("input").checked;

//                   var ch=op.querySelector("input").checked;
//                   list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)")
//                     .forEach(i=>{if(i.style.display!=='none'){i.querySelector("input").checked=ch; i.optEl.selected=ch}});

//                   el.dispatchEvent(new Event('change'));
//                 });
//                 ic.addEventListener('click',(ev)=>{
//                   ic.checked=!ic.checked;
//                 });
//                 el.addEventListener('change', (ev)=>{
//                   let itms=Array.from(list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)")).filter(e=>e.style.display!=='none')
//                   let existsNotSelected=itms.find(i=>!i.querySelector("input").checked);
//                   if(ic.checked && existsNotSelected) ic.checked=false;
//                   else if(ic.checked==false && existsNotSelected===undefined) ic.checked=true;
//                 });

//                 list.appendChild(op);
//               }

//               Array.from(el.options).map(o=>{
//                 var op=newEl('div',{class:o.selected?'checked':'',optEl:o})
//                 var ic=newEl('input',{type:'checkbox',checked:o.selected});
//                 op.appendChild(ic);
//                 op.appendChild(newEl('label',{text:o.text}));

//                 op.addEventListener('click',()=>{
//                   op.classList.toggle('checked');
//                   op.querySelector("input").checked=!op.querySelector("input").checked;
//                   op.optEl.selected=!!!op.optEl.selected;
//                   el.dispatchEvent(new Event('change'));
//                 });
//                 ic.addEventListener('click',(ev)=>{
//                   ic.checked=!ic.checked;
//                 });
//                 o.listitemEl=op;
//                 list.appendChild(op);
//               });
//               div.listEl=listWrap;

//               div.refresh=()=>{
//                 div.querySelectorAll('span.optext, span.placeholder').forEach(t=>div.removeChild(t));
//                 var sels=Array.from(el.selectedOptions);
//                 if(sels.length>(el.attributes['multiselect-max-items']?.value??5)){
//                   div.appendChild(newEl('span',{class:['optext','maxselected'],text:sels.length+' '+config.txtSelected}));
//                 }
//                 else{
//                   sels.map(x=>{
//                     var c=newEl('span',{class:'optext',text:x.text, srcOption: x});
//                     if((el.attributes['multiselect-hide-x']?.value !== 'true'))
//                       c.appendChild(newEl('span',{class:'optdel',text:'🗙',title:config.txtRemove, onclick:(ev)=>{c.srcOption.listitemEl.dispatchEvent(new Event('click'));div.refresh();ev.stopPropagation();}}));

//                     div.appendChild(c);
//                   });
//                 }
//                 if(0==el.selectedOptions.length) div.appendChild(newEl('span',{class:'placeholder',text:el.attributes['placeholder']?.value??config.placeholder}));
//               };
//               div.refresh();
//             }
//             el.loadOptions();

//             search.addEventListener('input',()=>{
//               list.querySelectorAll(":scope div:not(.multiselect-dropdown-all-selector)").forEach(d=>{
//                 var txt=d.querySelector("label").innerText.toUpperCase();
//                 d.style.display=txt.includes(search.value.toUpperCase())?'block':'none';
//               });
//             });

//             div.addEventListener('click',()=>{
//               div.listEl.style.display='block';
//               search.focus();
//               search.select();
//             });

//             document.addEventListener('click', function(event) {
//               if (!div.contains(event.target)) {
//                 listWrap.style.display='none';
//                 div.refresh();
//               }
//             });
//           });

//     }

// }
